<template>
  <div>
    <div
      id="online_users_show"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="online_users_showLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="standard-modalLabel">کاربران آنلاین</h4>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-hidden="true"
            ></button>
          </div>
          <div class="modal-body">
            <table class="table table-striped table-centered mb-0">
              <tbody>
                <tr
                  v-for="(user, index) in $store.state.online_users_full"
                  :key="index"
                >
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td>
                    {{ user.name }}
                  </td>
                  <td>
                    {{ user.role }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <div class="navbar-custom">
      <ul class="list-unstyled topbar-menu float-end mb-0">
      

        <li class="mt-2 px-1" style="cursor: pointer" @click="goTo('notifications')">
          <div
            class="d-flex flex-column justify-content-center align-items-center"
          >
            <div class="position-relative mt-1">
              <i
                class="fa-solid fa-bell me-1"
                style="font-size: 20px; color: #0069d1"
              ></i>
              <span
                v-if="$store.state.notices != 0"
                class="position-absolute top-0 start-0 translate-middle badge rounded-pill bg-danger fw-light"
              >
                {{ $store.state.notices }}
              </span>
            </div>
          </div>
        </li>

        <li
          class="mt-2 px-0"
          style="cursor: pointer"
          data-bs-toggle="modal"
          data-bs-target="#online_users_show"
        >
          <div
            class="d-flex flex-column justify-content-center align-items-center"
          >
            <div class="position-relative mt-1">
              <i
                class="fa-solid fa-users mx-1"
                style="font-size: 20px; color: #0069d1"
              ></i>
              <span
                class="position-absolute top-0 start-0 translate-middle badge rounded-pill bg-success fw-light"
              >
                {{ $store.state.online_users.length }}
              </span>
            </div>
          </div>
        </li>

        <li>
          <div
            class="d-flex flex-column justify-content-center align-items-center"
          >
            <div>
              <img
                :src="$store.state.company_logo"
                class="mt-1"
                style="width: 40px"
                alt=""
              />
            </div>
            <div class="text-center">
              {{ date }}
              <br />
              {{ time }}
            </div>
          </div>
        </li>
        <li class="dropdown">
          <a
            class="nav-link dropdown-toggle arrow-none nav-user px-2"
            data-bs-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <span class="account-user-avatar">
              <img
                v-if="$store.state.image != null"
                :src="$store.state.image"
                alt="user-image"
                width="32"
                class="rounded-circle"
              />
              <img
                v-if="$store.state.image == null"
                src="/images/profile.webp"
                alt="user-image"
                width="32"
                class="rounded-circle"
              />
            </span>
            <h5 class="d-flex d-md-none my-0" style="font-size: 10px">
              {{ $store.state.name }}
            </h5>
            <h6
              class="d-flex d-md-none my-0 fw-normal mt-1"
              style="font-size: 10px"
            >
              {{ $store.state.role }}
            </h6>

            <span class="d-lg-flex flex-column gap-1 d-none">
              <h5 class="my-0">
                {{ $store.state.name }} {{ $store.state.family }}
              </h5>
              <h6 class="my-0 fw-normal">{{ $store.state.role }}</h6>
            </span>
          </a>
          <div
            class="dropdown-menu dropdown-menu-end dropdown-menu-animated profile-dropdown"
          >
            <router-link
              :to="{ name: 'profile' }"
              class="dropdown-item notify-item"
            >
              <i class="fa-solid fa-user me-1"></i>
              <span>تنظیمات کاربری</span>
            </router-link>
            <button @click="exit()" class="dropdown-item notify-item">
              <i class="fa-solid fa-arrow-right-from-bracket me-1"></i>
              <span>خروج</span>
            </button>
          </div>
        </li>
      </ul>

      <button class="button-menu-mobile open-left">
        <i class="fa-solid fa-bars"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import cookie from "vue-cookies";
import router from "@/router";
import axios from "axios";

export default {
  computed: {
    ...mapGetters(["getPage", "getName", "getRole"]),
  },
  created() {
    this.setPage("dashboard");
    this.front_domain = process.env.VUE_APP_FRONT_URL;
    var self = this;
    setInterval(function () {
      var date = new Date().toLocaleDateString("fa-IR", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      });
      var currentdate = new Date();
      var datetime =
        currentdate.getHours() +
        ":" +
        currentdate.getMinutes() +
        ":" +
        currentdate.getSeconds();
      self.time = datetime;
      self.date = date;
    }, 1000);
  },
  data() {
    return {
      time: "",
      date: "",
      front_domain: "",
      isOnline: true,
    };
  },
  methods: {
    ...mapActions(["setPage"]),
    exit() {
      cookie.set("reval_token", "s", -1400, null);
      cookie.set("ravan_reval_status", "s", -1400, null);
      location.reload();
    },
    goTo(route, data) {
      if (route == "notifications") {
        router.push("/notifications");
      }
    },
  },
};
</script>
